<template>
  <modal
    v-model="showLicenseSelector"
    size="sm"
    title="Select License Type"
    :append-to-body="true"
    :dismiss-btn="false"
    :footer="false">
    <LicenseSelector
      :user-license="license"
      @select:confirmed="onConfirm"
      @select:canceled="closeModal"
    />
  </modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import LicenseSelector from './LicenseSelector'

export default {
  name: 'LicenseSelectorContainer',
  components: {
    LicenseSelector
  },
  computed: {
    ...mapState('user', ['showLicenseSelector', 'license'])
  },
  methods: {
    ...mapMutations('user', [
      'setLicense',
      'setLicenseSelectorOpen',
    ]),
    onConfirm(license) {
      if (license) {
        this.setLicense(license)
      }
      this.closeModal()
    },
    closeModal() {
      this.setLicenseSelectorOpen(false)
    }
  }
}
</script>
